import { Search, Compass, PenTool, Play, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const steps = [
    { n: "01", title: "Understand", desc: "Research, context, users and business goals.", icon: Search },
    { n: "02", title: "Explore", desc: "User flows, information architecture and ideas.", icon: Compass },
    { n: "03", title: "Design", desc: "Wireframes, visual design and interaction.", icon: PenTool },
    { n: "04", title: "Prototype", desc: "Bring ideas to life and test the experience.", icon: Play },
    { n: "05", title: "Refine", desc: "Iterate, simplify and polish.", icon: Sparkles },
];

export default function Process() {
    return (
        <section className="relative overflow-hidden py-24 lg:py-32" data-testid="process-section">
            <div
                className="pointer-events-none absolute inset-0 bg-dots opacity-30"
                style={{
                    maskImage: "radial-gradient(ellipse at center, black 15%, transparent 65%)",
                    WebkitMaskImage: "radial-gradient(ellipse at center, black 15%, transparent 65%)",
                }}
            />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal className="text-center">
                    <div className="flex justify-center"><Eyebrow>Process</Eyebrow></div>
                    <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                        How I turn ideas into{" "}
                        <span className="relative inline-block">
                            <span className="relative z-10">experiences.</span>
                            <span className="absolute bottom-1 left-0 z-0 h-3.5 w-full rounded-sm bg-sun" />
                        </span>
                    </h2>
                </Reveal>

                <div className="relative mt-16">
                    <svg
                        className="absolute left-0 right-0 top-8 hidden h-8 w-full lg:block"
                        viewBox="0 0 1000 32"
                        fill="none"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                    >
                        <path
                            d="M0 16 C 120 4, 240 28, 360 16 S 600 4, 720 16 S 920 28, 1000 16"
                            stroke="#7047F5"
                            strokeOpacity="0.35"
                            strokeWidth="2"
                            strokeDasharray="7 7"
                            strokeLinecap="round"
                        />
                    </svg>

                    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
                        {steps.map((s, i) => (
                            <Reveal key={s.n} delay={i * 0.1} className="relative">
                                <div
                                    className="group flex flex-row items-start gap-4 lg:flex-col lg:items-center lg:text-center"
                                    data-testid={`process-step-${i + 1}`}
                                >
                                    <div className="relative shrink-0">
                                        <span
                                            className={`flex h-16 w-16 items-center justify-center rounded-2xl shadow-sm transition-all duration-300 group-hover:-translate-y-1.5 group-hover:rotate-3 ${
                                                i % 2 === 0
                                                    ? "bg-viol text-white shadow-[0_10px_25px_rgba(112,71,245,0.3)]"
                                                    : "bg-sun text-ink shadow-[0_10px_25px_rgba(255,216,77,0.4)]"
                                            }`}
                                        >
                                            <s.icon className="h-6 w-6" />
                                        </span>
                                        <span className="hand absolute -right-3 -top-3 rotate-6 text-xl text-viol">
                                            {s.n}
                                        </span>
                                    </div>
                                    <div className="lg:mt-4">
                                        <h3 className="text-lg font-extrabold text-ink">{s.title}</h3>
                                        <p className="mt-1.5 text-sm leading-relaxed text-mist">{s.desc}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
